import { useAuth } from "../../context/auth-context";
import { apiQueryKey } from "./queryKeys";
import { useApiQuery } from "./useApiQuery";
import type {
  AdminTransactionsDataEnvelope,
  AdminTransactionsDataPayload,
} from "./adminTransactionsData";

const DEFAULT_LIMIT = 25;

export type OrderSubtypeFilter =
  | "all"
  | "sell"
  | "deposit"
  | "swap"
  | "withdrawal";

export type UseAdminTransactionsDataParams = {
  page: number;
  /** Omitted when "all"; otherwise sent as `orderSubtypes`. */
  orderSubtype: OrderSubtypeFilter;
  search?: string;
  startDate?: string;
  endDate?: string;
  limit?: number;
  enabled?: boolean;
};

export function useAdminTransactionsDataQuery(
  params: UseAdminTransactionsDataParams
) {
  const { isAuthenticated } = useAuth();
  const {
    page,
    orderSubtype,
    search,
    startDate,
    endDate,
    limit = DEFAULT_LIMIT,
    enabled: enabledParam = true,
  } = params;

  const orderSubtypes = orderSubtype === "all" ? undefined : orderSubtype;

  return useApiQuery<
    AdminTransactionsDataEnvelope,
    AdminTransactionsDataPayload
  >({
    queryKey: apiQueryKey("admin-transactions-data", {
      type: "orders",
      page,
      limit,
      orderSubtypes: orderSubtypes ?? null,
      search: search?.trim() || null,
      startDate: startDate ?? null,
      endDate: endDate ?? null,
    }),
    url: "api/admin/transactions/data",
    params: {
      type: "orders",
      page,
      limit,
      orderSubtypes,
      search: search?.trim() || undefined,
      startDate,
      endDate,
    },
    enabled: Boolean(isAuthenticated) && enabledParam,
    select: (body) => body.data,
  });
}
